
import { loadConfiguration } from '../helpers/CMS/Configuration';
import * as Chat from '../helpers/CMS/Chat';

export const MediaSrcTypes = {
  mp4: 'mp4',
  mp3: 'mp3',
  live: 'live',
};  

export const colorConversionToCss = (colorObject = {}) => {
  if( !colorObject) colorObject = { r: 0, g: 0, b: 0, a: 1 };
  return `rgba(${colorObject.r}, ${colorObject.g}, ${colorObject.b}, ${colorObject.a})`;
};

const CMS = {

  loadConfiguration: ( iframeId) => {
    return loadConfiguration( iframeId);
  },

  Chat,

};

export default CMS;
